<template>
    <v-card class="pa-10">
      <validation-observer ref="validator">
        <div class="close-model">
          <v-icon @click="$emit('closePopup')" large>mdi-close</v-icon>
        </div>
        <div>
          <h3>BrandName</h3>
          <div class="d-flex align-center px-5">
            <div class="label">
              <label for="">Tên BrandName*</label>
            </div>
           <div class="input-script">
              <validation-provider
              v-slot="{ errors }"
              rules="required"
              name="Tên BrandName"
            >
              <v-text-field
                :error-messages="errors"
                outlined
                dense
                placeholder="Nhập BrandName"
                v-model="brand.name"
              />
            </validation-provider>
           </div>
          </div>
          <div class="d-flex align-center px-5">
            <div class="label">
              <label for="">Mã BrandName*</label>
            </div>
            <div class="input-script">
            <validation-provider v-slot="{ errors }" rules="required" name="Code">
              <v-text-field
                :error-messages="errors"
                outlined
                dense
                placeholder="Nhập mã BrandName"
                v-model="brand.code"
                :disabled="!_.isEmpty(itemBrand)"
              />
            </validation-provider>
            </div>
          </div>
        </div>
        <!-- <div class="submit-script pr-11 py-4">
          <v-btn rounded @click="$emit('closePopup')">Bỏ qua</v-btn>
          <v-btn rounded color="#FF6609" @click="handleSubmit(submitSave)"
            >Lưu lại</v-btn
          >
        </div> -->
      </validation-observer>
    </v-card>
  </template>
  <script>
  import RepositoryFactory from "../../../repositories/RepositoryFactory";
  const ScriptRepository = RepositoryFactory.get("script");
  export default {
    data() {
      return {
        brand: {
            code: null,
            name: null,
        }
      };
    },
    props: {
      // listBrands: {
      //   type: Array,
      //   default: () => [],
      // },
      itemBrand: {
        type: Object,
        default: () => {}
      }
    },
    created() {
      if(!_.isEmpty(this.itemBrand)) {
        this.brand = this.itemBrand
      };     
    },
    methods: {
      async submitSave() {
        this.submit.scriptDetail.map(s => {
        const find = _.find(this.groups, ['id', s.groupId])
        s.brandnameCode = find.brandnameCode
        return s
        })
        if(this.submit.type == 'manual') {
          delete this.submit.periodTime
        }
        let res
        if(!_.isEmpty(this.itemBrand)) {
          let code = this.submit.code
          let params = _.omit(this.submit, 'code')   
           res = await ScriptRepository.updateBrand(code, params);
        }else {
          
           res = await ScriptRepository.createBrand(this.submit);
        }
        
        if (res.success) {
          this.$swal({
            type: "success",
            title: !_.isEmpty(this.itemBrand) ? 'Cập nhật thành công!' : "Tạo thành công!",
            timer: 1500,
          });
          this.$emit("getListBrands");
        }else {
          this.$swal({
            type: "error",
            title: "Lỗi !",
            timer: 1500,
            text: _.get(res, "message", ""),
          })
        }
      },
    }
  }
  
  </script>
  <style scoped>
  .label {
    min-width: 156px;
  }
  .input-script {
      width: calc(100% - 200px);
  }
  .add-script {
    display: flex;
    width: 85%;
    justify-content: center;
    color: #2f80ed;
    text-decoration: underline;
    cursor: pointer;
  }
  .delete-script {
    display: flex;
    width: 85%;
    justify-content: right;
    color: #2f80ed;
    text-decoration: underline;
    cursor: pointer;
  }
  .submit-script {
    display: flex;
    width: 100%;
    justify-content: right;
  }
  .close-model {
    position: absolute;
    top: 15px;
    right: 20px;
  }
  </style>